import * as types from '../actions/actionTypes'; 
import initialState from './initialState';


//all the offering related reducers here
export default function (state = initialState.user, action) { //we will change the state = {} soon
  switch(action.type) {
    case types.DO_STOCKTWITS_ACCOUNT_RES:
      return action.data.data
    default:
      return state
  }
}